import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_AFFILIATE_STATE,
});

export const createAffiliate = (affiliate) => ({
  type: types.CREATE_AFFILIATE.REQUEST,
  affiliate,
});

export const createAffiliateSuccess = (affiliate) => ({
  type: types.CREATE_AFFILIATE.SUCCESS,
  affiliate,
});

export const createAffiliateFailure = (error) => ({
  type: types.CREATE_AFFILIATE.FAILURE,
  error,
});

export const updateAffiliate = (affiliateId, updates) => ({
  type: types.UPDATE_AFFILIATE.REQUEST,
  affiliateId,
  updates,
});

export const updateAffiliateSuccess = (affiliate) => ({
  type: types.UPDATE_AFFILIATE.SUCCESS,
  affiliate,
});

export const updateAffiliateFailure = (error) => ({
  type: types.UPDATE_AFFILIATE.FAILURE,
  error,
});

export const syncAffiliates = () => ({
  type: types.SYNC_AFFILIATES.REQUEST,
});

export const syncAffiliatesSuccess = (affiliates) => ({
  type: types.SYNC_AFFILIATES.SUCCESS,
  affiliates,
});

export const syncAffiliatesFailure = (error) => ({
  type: types.SYNC_AFFILIATES.FAILURE,
  error,
});
